function getStatus(set) {
  const statusArray = set.statusArray;
  const totalStatus = set.sets || set.rounds || 1;
  const currentStatus = statusArray
    ? statusArray.reduce(
        (prev, current) => prev + (current.status === "completed" ? 1 : 0),
        0
      )
    : 0;
  return currentStatus === 0
    ? "Missed"
    : currentStatus == totalStatus
    ? "Completed"
    : `${currentStatus}/${totalStatus}Completed`;
}

export default getStatus;
